<div>
	<div
		class="h-[150px] cursor-pointer rounded bg-white p-3 drop-shadow-md"
		[class.activeGrid]="value"
		(click)="onCheckBoxClick(cntrl)"
	>
		<div class="flex flex-row items-center justify-between">
			<span class="grid-title text-lg font-bold">{{ title }}</span>
			<div class="checkbox grid-checkBox">
				<mat-checkbox [checked]="value" [color]="'primary'">
					@if (!value) {
						<mat-icon class="grid-icon text-lg !text-violet">add_box</mat-icon>
					}
					@if (value) {
						<mat-icon class="grid-icon text-lg text-violet">indeterminate_check_box</mat-icon>
					}
				</mat-checkbox>
			</div>
		</div>
		<p class="grid-description text-grey-40">
			{{ description }}
		</p>
	</div>
</div>
